import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { CommonModule } from '@angular/common'; // Importa CommonModule
import { UserService } from '../service/UserService'; // Ajusta la ruta a tu UserService
import { Coupon, PromoCode } from '../shared/models/coupon';
import { catchError, Observable, throwError } from 'rxjs';

@Component({
  selector: 'app-coupon',
  standalone: true,
  imports: [CommonModule], // Agrega CommonModule aquí
  templateUrl: './coupon.component.html',
  styleUrl: './coupon.component.scss'
})
export class CouponComponent implements OnInit {

  coupons: PromoCode[] = [];
  isLoading: boolean = false;
  error: string | null = null;

  constructor(
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.getPromoCodes();
  }

  getPromoCodes(): void {
    this.isLoading = true;
    this.error = null;

    // Obtener la cadena JSON del campo 'cliente' en sessionStorage
    const clienteJson = localStorage.getItem('cliente');

    if (clienteJson) {
      try {
        // Analizar la cadena JSON para obtener el objeto del cliente
        const cliente = JSON.parse(clienteJson);
        // Extraer el uid del objeto del cliente
        const userId = cliente.uid;

        if (userId) {
          // Si el ID del usuario existe, llamar al servicio para obtener los cupones personalizados
          this.userService.getPersonalizedPromoCode(userId).pipe(
              catchError((error: HttpErrorResponse) => {
                  this.isLoading = false;
                  this.error = 'No se pudieron cargar los cupones. Inténtalo de nuevo más tarde.';
                  console.error('Error fetching coupons:', error);
                  return throwError(() => new Error('Error al cargar cupones.'));
              })
          ).subscribe((data: Coupon) => {
              if (data && data.promoCodes) {
                  this.coupons = data.promoCodes;
              } else {
                  this.coupons = [];
              }
              this.isLoading = false;
          });
        } else {
            this.isLoading = false;
            this.error = 'La información de usuario no es válida. Falta el ID de usuario.';
            console.error('Error: UID not found in parsed client object.');
        }
      } catch (e) {
        // Manejar el caso si la cadena de sessionStorage no es un JSON válido
        this.isLoading = false;
        this.error = 'Error al procesar la información de usuario. Por favor, inicia sesión de nuevo.';
        console.error('Error: Could not parse client data from sessionStorage.', e);
      }
    } else {
      // Si el ID del usuario no está en sessionStorage, manejar el error
      this.isLoading = false;
      this.error = 'No se encontró tu información de usuario. Por favor, inicia sesión de nuevo.';
      console.error('Error: User ID not found in sessionStorage.');
    }
  }

  async copyCouponCode(code: string): Promise<void> {
    try {
      await navigator.clipboard.writeText(code);
      alert('Código de cupón copiado: ' + code);
    } catch (err) {
      console.error('Failed to copy: ', err);
      alert('No se pudo copiar el código. Por favor, cópialo manualmente: ' + code);
    }
  }

  shareOnWhatsApp(coupon: PromoCode): void {
    const text = `¡Hola! Te comparto este cupón de ${coupon.title}. ${coupon.description} regístrate para ganar el cúpon ${coupon.code} en https://camben.com.mx/product. ¡Aprovecha!`;
    const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(url, '_blank');
  }

  shareCoupon(coupon: PromoCode): void {
    if (navigator.share) {
      navigator.share({
        title: coupon.title,
        text: `¡Mira este cupón! ${coupon.description}. Código: ${coupon.code}. Usalo en www.camben.com.mx`,
        url: window.location.href
      }).catch((error) => console.log('Error al compartir', error));
    } else {
      // Fallback para navegadores que no soportan la Web Share API
      alert('Tu navegador no soporta la función de compartir. Por favor, copia el texto y pégalo en tus redes sociales.');
    }
  }

  async downloadCouponImage(imageUrl: string, fileName: string): Promise<void> {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${fileName}.jpg`; // O el formato de imagen que corresponda
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al descargar la imagen:', error);
      alert('No se pudo descargar la imagen del cupón.');
    }
  }
}
